import type { ReactNode } from 'react'
import { AlertTriangle, ArrowLeft, KeyRound } from 'lucide-react'
import { Link, useParams } from 'react-router'
import { ApiContractError, ApiError } from '@/api/client'
import { ProducttypeCard } from '@/features/keywordAnalysis/KeywordAnalysisPage'
import { useKeywordProducttype } from '@/features/keywordAnalysis/useKeywordProducttype'
import { KeywordAreaNav } from '@/features/keywords/KeywordAreaNav'

export function KeywordProducttypeDetailPage(): ReactNode {
  const producttypeKey = useParams<{ producttypeKey: string }>().producttypeKey ?? ''
  const { data, isLoading, error } = useKeywordProducttype(producttypeKey)

  return (
    <div className="mx-auto max-w-7xl px-4 py-8 sm:px-6 lg:px-8 lg:py-12">
      <KeywordAreaNav />

      <div className="mb-5 flex flex-wrap items-center justify-between gap-3">
        <div>
          <div className="flex items-center gap-2 text-sm font-semibold text-violet-700 dark:text-violet-300">
            <KeyRound aria-hidden="true" size={16} />
            Produkttyp-Keywords
          </div>
          <h1 className="mt-1 text-2xl font-black text-slate-950 dark:text-white">
            {data?.producttypeName ?? producttypeKey}
          </h1>
        </div>
        <Link
          to="/producttype-keywords/analysis"
          className="inline-flex items-center gap-2 rounded-xl border border-slate-300 bg-white px-4 py-2.5 text-sm font-semibold text-slate-700 dark:border-slate-700 dark:bg-slate-900 dark:text-slate-200"
        >
          <ArrowLeft aria-hidden="true" size={16} />
          Zur Keyword-Analyse
        </Link>
      </div>

      {error !== null ? (
        <div className="flex items-start gap-2 rounded-2xl border border-red-200 bg-red-50 p-5 text-red-900 dark:border-red-900 dark:bg-red-950 dark:text-red-100">
          <AlertTriangle aria-hidden="true" size={19} />
          <p className="text-sm font-medium">
            {error instanceof ApiError || error instanceof ApiContractError
              ? error.message
              : 'Der Produkttyp konnte nicht geladen werden.'}
          </p>
        </div>
      ) : isLoading ? (
        <div className="h-72 animate-pulse rounded-2xl border border-slate-200 bg-white dark:border-slate-700 dark:bg-slate-900" />
      ) : data === null || data === undefined ? (
        <div className="rounded-2xl border border-dashed border-slate-300 bg-white px-6 py-16 text-center font-semibold text-slate-700 dark:border-slate-700 dark:bg-slate-900 dark:text-slate-200">
          Dieser Produkttyp wurde nicht gefunden.
        </div>
      ) : (
        <ProducttypeCard producttype={data} />
      )}
    </div>
  )
}
